import { OrderMode, OptionMode } from '../../../../../../utProto/enums_pb';
import { ExpiryType, StrikeSelectionType, PortfolioStrategyType, MtmCheckType, ExpiryMonthlyOffsetType, LegExitTypes, ReOrderConditionTypes, WaitToTradeTypes, OpenInterestStrikeType } from '../../../../../../utProto/webApiStrategyEnums_pb';
import { defaultAlgoParams } from '@app/_shared/providers';
import { INDEX_SYMBOLS_ORDER, MIN_ABSOLUTE_VALUE, MOMENT_TIME_FORMAT } from '@app/_helpers';
import * as moment from 'moment';
import { EXIT_EXECUTION_DAYS_VALUES, EXPIRY_OFFSET_TYPES_STRING } from '../../portfolio-form.enums';
import { EXPIRY_WEEKLY_OFFSET_TYPES_STRING } from '../../portfolio-form.constants';
import { PriceMethodNew } from '../../../../../../utProto/webAlertStructureEnums_pb';
import { MAX_DEPTH_TYPE } from '@app/_shared/modules/strategy-form/strategy.enums';

export const defaultExitForm = {
    percentageValue: false,
    underlyingType: LegExitTypes.LEGEXITTYPES_UNDERLYING_POINTS.toString(),
    netPL: true,
    underlyingMinValue: null,
    underlyingMaxValue: null,
    TPEnabled: false,
    targetProfitType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    targetProfitValue: 5,
    SLEnabled: false,
    stopLossType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    stopLossValue: 5,
    trailSLEnabled: false,
    trailSLType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    trailSLValue: 5,
    increaseBy: 1,
    costTypeEnabled: false,
    costType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    costValue: 5
}

export const atmValues = {
    atm: 0,
    atmPlus: 1,
    atmMinus: -1
}

// For Index symbols,  index will be 4 except IRON CONDOR, it will be 8 for that
// For Other symbols index will be 2 except IRON CONDOR, it will be 4 for that

const customLegFormDetails = {
    orderMode: OrderMode.ORDERMODE_BUY.toString(),
    instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
    expiryType: ExpiryType.EXPIRYTYPE_BASIC.toString(),
    expiryOffset: null,
    strikePrice: StrikeSelectionType.STRIKESELECTIONTYPE_ATM.toString(),
    lotMultiplier: 1,
    legSettings: false,
    waitToTradeToggle: false,
    waitToTradeType: WaitToTradeTypes.WAITTOTRADETYPES_POINT.toString(),
    waitToTradeValue: null,
    exitForm: defaultExitForm,
    rangeThreshold: false,
    indexValue: function (symbol) {
        const index = (INDEX_SYMBOLS_ORDER.indexOf(symbol)) != -1 ? 4 : 2;
        return index;
    }

}


export const DEFAULT_LEGS_DETAILS = {
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_CUSTOM]: [{
        ...customLegFormDetails,
        atmValues: atmValues.atm,
    }],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_STRADDLE]: [
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atm
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atm
        }

    ],
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_STRADDLE]: [
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atm
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atm
        }

    ],
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_STRANGLE]: [
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atmPlus
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atmMinus
        }

    ],
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_STRANGLE]: [
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atmPlus
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atmMinus
        }

    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_CALL]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atm
    }],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_CALL]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atm
    }],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_PUT]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atm
    }],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_PUT]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atm
    }],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_BULL_CALL_SPREAD]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atm
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atmPlus
    }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_BULL_PUT_SPREAD]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atm
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atmMinus
    }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_BEAR_CALL_SPREAD]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atm
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atmPlus
    }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_BEAR_PUT_SPREAD]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atm
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atmMinus
    }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_IRON_BUTTERFLY]: [
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atm
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atmPlus
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atm
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atmMinus
        }


    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_IRON_BUTTERFLY]: [
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atm
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atmPlus
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atm
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atmMinus
        }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_IRON_CONDOR]: [
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atmPlus
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atmPlus,
            indexValue: function (symbol) {
                const index = (INDEX_SYMBOLS_ORDER.indexOf(symbol)) != -1 ? 8 : 4;
                return index;
            }
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atmMinus,
            indexValue: function (symbol) {
                const index = (INDEX_SYMBOLS_ORDER.indexOf(symbol)) != -1 ? 8 : 4;
                return index;
            }
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atmMinus
        }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_IRON_CONDOR]: [
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atmPlus
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
            atmValues: atmValues.atmPlus,
            indexValue: function (symbol) {
                const index = (INDEX_SYMBOLS_ORDER.indexOf(symbol)) != -1 ? 8 : 4;
                return index;
            }
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_BUY.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atmMinus,
            indexValue: function (symbol) {
                const index = (INDEX_SYMBOLS_ORDER.indexOf(symbol)) != -1 ? 8 : 4;
                return index;
            }
        },
        {
            ...customLegFormDetails,
            orderMode: OrderMode.ORDERMODE_SELL.toString(),
            instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
            atmValues: atmValues.atmMinus
        }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_CALL_BUTTERFLY]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atmMinus
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atm,
        lotMultiplier: 2
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atmPlus
    }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_CALL_BUTTERFLY]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atmMinus
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atm,
        lotMultiplier: 2
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_CALL.toString(),
        atmValues: atmValues.atmPlus
    }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_PUT_BUTTERFLY]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atmMinus
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atm,
        lotMultiplier: 2
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atmPlus
    }
    ],

    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_PUT_BUTTERFLY]: [{
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atmMinus
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_BUY.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atm,
        lotMultiplier: 2
    },
    {
        ...customLegFormDetails,
        orderMode: OrderMode.ORDERMODE_SELL.toString(),
        instrumentType: OptionMode.OPTIONMODE_PUT.toString(),
        atmValues: atmValues.atmPlus
    }
    ],
}

export const OPEN_INTEREST_LEGS_OPTIONS = {
    "Max": OpenInterestStrikeType.OPENINTEREST_MAX,
    "Max 1": OpenInterestStrikeType.OPENINTEREST_MAX_1,
    "Max 2": OpenInterestStrikeType.OPENINTEREST_MAX_2,
    "Max Change": OpenInterestStrikeType.OPENINTEREST_CHANGEMAX,
    "Max Change 1": OpenInterestStrikeType.OPENINTEREST_CHANGEMAX_1,
    "Max Change 2": OpenInterestStrikeType.OPENINTEREST_CHANGEMAX_2,
} 

export const MAX_DEPTH_OPTIONS = {
    "ITM": MAX_DEPTH_TYPE.ITM,
    "OTM": MAX_DEPTH_TYPE.OTM,
    "Both": MAX_DEPTH_TYPE.BOTH,
    "Diff": MAX_DEPTH_TYPE.DIFF
}

export const DEFAULT_OI_BASED_TIMER = 60;

export const DEFAULT_EXIT_VALUES = {
    entryPriceMethod: PriceMethodNew.PRICEMETHODNEW_HBA.toString(),
    percentageValue: false,
    TPEnabled: false,
    targetProfitType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    targetProfitValue: 5,
    targetProfitMin: null,
    targetProfitMax: null,
    SLEnabled: false,
    stopLossType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    stopLossValue: 5,
    stopLossMin: null,
    stopLossMax: null,
    trailSLEnabled: false,
    trailSLType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    trailSLValue: 5,
    increaseBy: MIN_ABSOLUTE_VALUE,
    costTypeEnabled: false,
    costType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    costValue: 5,
    startTime: moment(defaultAlgoParams.startTime, MOMENT_TIME_FORMAT).toDate(),
    endTime: moment(defaultAlgoParams.closeTime, MOMENT_TIME_FORMAT).toDate(),
    executeDays: Object.keys(EXIT_EXECUTION_DAYS_VALUES),
    tpReEntryToggle: false,
    tpReEntryType: ReOrderConditionTypes.REORDERCONDITIONTYPES_RE_EXECUTION.toString(),
    tpReEntryValue: 1,
    slReEntryToggle: false,
    slReEntryType: ReOrderConditionTypes.REORDERCONDITIONTYPES_RE_EXECUTION.toString(),
    slReEntryValue: 1,
    trailLockedProfitType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    trailLockedProfitValue: 5,
    underlyingType: LegExitTypes.LEGEXITTYPES_UNDERLYING_POINTS.toString(),
    underlyingMinValue: null,
    underlyingMaxValue: null,
    isTrailLockedProfit: false,
    lockProfitAt: MIN_ABSOLUTE_VALUE,
    onIncreaseOf: MIN_ABSOLUTE_VALUE,
    trailBy: MIN_ABSOLUTE_VALUE,
    exitIndicatorsToggle: false,
    trailLockedProfit: false,
    tpReOrderToggle: false,
    tpReOrderType: ReOrderConditionTypes.REORDERCONDITIONTYPES_RE_EXECUTION.toString(),
    tpReOrderValue: 1,
    slReOrderToggle: false,
    slReOrderType: ReOrderConditionTypes.REORDERCONDITIONTYPES_RE_EXECUTION.toString(),
    slReOrderValue: 1,
}


// model - src/app/_shared/modules/portfolio-form/components/strategy-leg-form/strategy-leg-form.constants

export const DEFAULT_GLOBAL_EXIT_VALUES = {
    GTPEnabled: false,
    globalTargetProfitType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    globalTargetProfitValue: 5,

    GSLEnabled: false,
    globalStopLossType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    globalStopLossValue: 5,

    trailGSLEnabled: false,
    trailGSLType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    trailGSLValue: 5,
    gslTrailBy: null,

    lgpType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    lgpVaue: 5,
    lgpLockProfitValue: 2,

    // Lock profit fields
    isTrailLockedProfit: false,
    trailLockedProfitValue: 5,
    trailLockedProfit: false,
    trailLockedProfitType: MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE.toString(),
    lockProfitAt: MIN_ABSOLUTE_VALUE,
    onIncreaseOf: MIN_ABSOLUTE_VALUE,
    trailBy: MIN_ABSOLUTE_VALUE,

    rememberSettings: false
}

export const controlsToWatch = [
    'orderMode',
    'instrumentType',
    'expiryType',
    'expiryOffset',
    'strikePriceValue',
    'lotMultiplier',
    'priceCriteria',
    'premium',
    'rangePercentageEnabled',
    'rangePercentageValue',
    'series'
  ];